export default "__VITE_ASSET__CJ19uK$x__"